import { StreamPlainObject } from '../plainObjects/stream.plainObject';
import { BaseTransformationVisitor } from './baseTransformation.visitor';

export class GuardVisitor extends BaseTransformationVisitor {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitOutputTransformed(outputTransformedContext: any): void {
        this.transformation.name = this._getText(outputTransformedContext.children[0]);
        const outputStreams = outputTransformedContext.groupName();

        if (outputStreams.length) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            outputStreams.forEach((child: any, index: number) => {
                const streamName = this.visitTransformed(child);
                this.transformation.outputStreams.push(new StreamPlainObject(streamName));
            });
        } else {
            this.transformation.name = this.visit(outputTransformedContext.transformed());
            const outputStream = new StreamPlainObject();
            this.transformation.outputStreams.push(outputStream);
        }
    }
}
